import PropTypes from 'prop-types'

import { useWindowWidth } from 'core/ui/hooks/useWindowWidth'

import { OfferExpirationBar } from 'legacy/components/OfferExpirationBar/OfferExpirationBar'
import { intSizes } from 'legacy/styles/screen'

import {
  ContractedBarSeparator,
  ContractedIcon,
  ExpirationContainer,
  ExpirationDescription,
  ExpirationHeading,
  ExpirationTitle,
  ExpirationUrgency,
  LoadCandidateIcon,
  RejectIcon,
} from './ExpirationInfo.styles'

function ExpirationInfo({
  created_at,
  expires_at,
  onExpiration,
  isContracted,
  handleRejectButton,
  isLoadCandidate,
}) {
  const windowWidth = useWindowWidth()
  const isSmallScreen = windowWidth <= intSizes.md

  return (
    <ExpirationContainer>
      <ExpirationHeading>
        <ExpirationTitle>
          {isContracted && (
            <>
              <ContractedIcon />
              <span>
                Contracted
                {!isSmallScreen && ' Load'}
              </span>
            </>
          )}

          {isLoadCandidate && (
            <>
              <LoadCandidateIcon />
              <span>
                ShipperDirect
                {!isSmallScreen && ' Load'}*
              </span>
            </>
          )}
        </ExpirationTitle>
        <ExpirationDescription>
          {isContracted && (
            <>
              <ContractedBarSeparator />
              <RejectIcon width={24} height={24} onClick={handleRejectButton} role="button" />
            </>
          )}

          {isLoadCandidate && '*The shipper will need to approve the booking'}
        </ExpirationDescription>
      </ExpirationHeading>

      <ExpirationUrgency>
        <OfferExpirationBar
          created_at={created_at}
          expires_at={expires_at}
          onExpiration={onExpiration}
          darkThemed
        />
      </ExpirationUrgency>
    </ExpirationContainer>
  )
}

ExpirationInfo.propTypes = {
  created_at: PropTypes.instanceOf(Date).isRequired,
  expires_at: PropTypes.instanceOf(Date).isRequired,
  onExpiration: PropTypes.func,
  isContracted: PropTypes.bool,
  isLoadCandidate: PropTypes.bool,
  handleRejectButton: PropTypes.func,
}

ExpirationInfo.defaultProps = {
  onExpiration: Function.prototype,
  isContracted: false,
  handleRejectButton: () => {},
  isLoadCandidate: false,
}

export { ExpirationInfo }
